import ForgotPasswordForm from './ForgotPassworForm';

export default ForgotPasswordForm;
